/* RESPONSIBLE TEAM: team-proactive-support */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    step: { key: 'step_id' },
    actionType: { embedded: 'always' },
    webUrl: { embedded: 'always' },
    actionTitle: { embedded: 'always' },
    androidUri: { embedded: 'always' },
    iosUri: { embedded: 'always' },
    actionContentId: { embedded: 'always' },
    actionContentType: { embedded: 'always' },
  },
});
